module.exports = __webpack_public_path__ + "static/media/icon_new_disabled.6befed12.svg";